module.exports = "<div *ngIf=\"enabled\" class=\"loading\">Loading&#8230;</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/shared/components/loading/loading.component.html
// module id = ../../../../../src/app/shared/components/loading/loading.component.html
// module chunks = main